import { getStorageSafely } from '@/utilities/storage.utilities';

const HELP_CENTER_BADGE_KEY = 'helpCenterBadgeDismissed';

/**
 * Gets the initial state for the Help Center badge visibility.
 * Returns true (show badge) if the badge hasn't been dismissed yet.
 */
export function getHelpCenterBadgeInitialState(): boolean {
  try {
    return getStorageSafely().getItem(HELP_CENTER_BADGE_KEY) !== 'true';
  } catch {
    // Intentionally ignore storage access errors
    return true;
  }
}

/**
 * Dismisses the Help Center badge by storing the dismissal in localStorage.
 */
export function dismissHelpCenterBadge(): void {
  try {
    getStorageSafely().setItem(HELP_CENTER_BADGE_KEY, 'true');
  } catch {
    // Intentionally ignore storage access errors
  }
}
